module.exports = __webpack_public_path__ + "img/Triangles-1s-200px.c2db3a7d.gif";